import { client } from '@/server';
import { Cinema } from '../user-cinema/user-cinema.interface';
export class CinemaService {
   async getAll() {
      throw Error('Method not implemented');
   }

   async get() {
      throw Error('Method not implemented');
   }

   async post(cinema: Cinema) {
      const query = `
         INSERT INTO cinemas (
            id,
            title,
            release_date,
            overview,
            cover_url,
            backdrop_url,
            vote_average,
            vote_count,
            popularity,
            adult,
            original_language,
            original_title,
            genre_ids,
            cinema_type
         ) VALUES (
            :id,
            :title,
            :release_date,
            :overview,
            :cover_url,
            :backdrop_url,
            :vote_average,
            :vote_count,
            :popularity,
            :adult,
            :original_language,
            :original_title,
            :genre_ids,
            :cinema_type
         )
      `;

      try {
         const response = await client.execute(query, {
            id: cinema.id,
            title: cinema.title,
            release_date: cinema.release_date,
            overview: cinema.overview,
            cover_url: cinema.cover_url,
            backdrop_url: cinema.backdrop_url,
            vote_average: cinema.vote_average,
            vote_count: cinema.vote_count,
            popularity: cinema.popularity,
            adult: cinema.adult,
            original_language: cinema.original_language,
            original_title: cinema.original_title,
            genre_ids: JSON.stringify(cinema.genre_ids), // Ensure genre_ids is stored as a JSON string
            cinema_type: cinema.cinema_type,
         });

         return response;
      } catch (error) {
         console.error('Error inserting cinema:', error);
         throw new Error('Failed to insert cinema');
      }
   }

   async put(cinema: Cinema) {
      const query = `
         UPDATE cinemas
         SET
            title = :title,
            release_date = :release_date,
            overview = :overview,
            cover_url = :cover_url,
            backdrop_url = :backdrop_url,
            vote_average = :vote_average,
            vote_count = :vote_count,
            popularity = :popularity,
            adult = :adult,
            original_language = :original_language,
            original_title = :original_title,
            genre_ids = :genre_ids,
            cinema_type = :cinema_type
         WHERE id = :id
      `;
      try {
         const response = await client.execute(query, {
            id: cinema.id,
            title: cinema.title,
            release_date: cinema.release_date,
            overview: cinema.overview,
            cover_url: cinema.cover_url,
            backdrop_url: cinema.backdrop_url,
            vote_average: cinema.vote_average,
            vote_count: cinema.vote_count,
            popularity: cinema.popularity,
            adult: cinema.adult,
            original_language: cinema.original_language,
            original_title: cinema.original_title,
            genre_ids: JSON.stringify(cinema.genre_ids), // Ensure genre_ids is stored as a JSON string
            cinema_type: cinema.cinema_type,
         });

         return response;
      } catch (error) {
         console.error('Error updating cinema:', error);
         throw new Error('Failed to update cinema');
      }
   }

   async delete() {
      throw Error('Method not implemented');
   }

   async exists(id: number) {
      const query = `
         SELECT COUNT(*) as count
         FROM cinemas
         WHERE id = ?
      `;
      try {
         const response = await client.execute(query, [id]);
         if (response.rows.length === 0) return false;
         const count = (response.rows[0].count as number) || 0;

         if (count === 0) return false;
         if (count > 1) {
            console.warn('Multiple cinemas found with the same ID:', id);
            return true;
         }
         return response.rows.length > 0;
      } catch (error) {
         console.error('Error checking if cinema exists:', error);
         return false;
      }
   }
}
